var _defs, _path, _path2, _text, _text2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRelinkerLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 82.51 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:#231f20;}.cls-2{fill:none;}.cls-3{font-size:24px;font-family:Candara-Light, Candara;font-weight:300;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.93,13.88a1.41,1.41,0,0,1,.18.17l5,5A6.3,6.3,0,1,1,45.2,28l-5-5a6.28,6.28,0,0,1,3-10.56,3.23,3.23,0,0,1,.56.9,5.29,5.29,0,0,0-2.82,9l5,5a5.3,5.3,0,0,0,7.5-7.5l-4.49-4.49A9.08,9.08,0,0,0,48.93,13.88ZM36.4,17.74l-4.49-4.49a5.3,5.3,0,1,1,7.5-7.5l5,5a5.3,5.3,0,0,1-2.82,9,3.23,3.23,0,0,0,.56.9A6.29,6.29,0,0,0,46.79,13a6.21,6.21,0,0,0-1.68-3l-5-5A6.3,6.3,0,0,0,31.2,14l5,5,.19.17A9.2,9.2,0,0,1,36.4,17.74Z",
    transform: "translate(-2.76)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.16,0h32V32h-32Z",
    transform: "translate(-2.76)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(0 25.53)"
  }, "Re")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(55.4 25.77)"
  }, "eR")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelinkerLogo);
export default __webpack_public_path__ + "static/media/relinker-logo.444de5e06b4ef0c2007af44a6fd46047.svg";
export { ForwardRef as ReactComponent };